import React, { useEffect, useState } from 'react'
import { ArrowRight, ArrowUp, BookOpen, Check, ChevronLeft, ChevronRight, Circle, Facebook, Instagram, Layout, Linkedin, Menu, Tv, Package, Smartphone, Twitter, X } from 'react-feather'
import aos from 'aos'


const Features = () => {
    useEffect(() => {
        aos.init({ duration: 2000 });
    }, [])

    return (
        <>
            {/* <!-- Start Service Area --> */}
            <div id="service" className="rn-service-area rn-section-gap section-separator">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" className="section-title text-left">
                                <span className="subtitle">Features</span>
                                <h2 className="title">What I Do</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row row--25 mt_md--10 mt_sm--10">

                        {/* <!-- Start Single Service --> */}
                        <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                            <div className="rn-service">
                                <div className="inner">
                                    <div className="icon">
                                            <Layout />
                                                </div>
                                    <div className="content">
                                        <h4 className="title"><a href="#">Web Application</a></h4>
                                        <p className="description">I Create Progress by Building Web Experiences We believe in building interactive web applications,
                                            To create experiences beyond our clients’ expectations</p>
                                        {/* <a className="read-more-button" href="#"><ArrowRight /></a> */}
                                    </div>
                                </div>
                                {/* <a className="over-link" href="#"></a> */}
                            </div>
                        </div>
                        {/* <!-- End SIngle Service --> */}

                        {/* <!-- Start Single Service --> */}
                        <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                            <div className="rn-service">
                                <div className="inner">
                                    <div className="icon">
                                        <Smartphone />
                                    </div>
                                    <div className="content">
                                        <h4 className="title"><a href="#">App Development</a></h4>
                                        <p className="description">I build experiences Leveraging latest technological tools & industry practices,
                                            I build high performance apps to scale your business.</p>
                                        {/* <a className="read-more-button" href="#"><i className="feather-arrow-right"></i></a> */}
                                    </div>
                                </div>
                                {/* <a className="over-link" href="#"></a> */}
                            </div>
                        </div>
                        {/* <!-- End SIngle Service --> */}
                        {/* <!-- Start Single Service --> */}
                        <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="300" data-aos-once="true" className="col-lg-6 col-xl-4 col-md-6 col-sm-12 col-12 mt--50 mt_md--30 mt_sm--30">
                            <div className="rn-service">
                                <div className="inner">
                                    <div className="icon">
                                     <Package />
                                    </div>
                                    <div className="content">
                                        <h4 className="title"><a href="#">BlockChain Development</a></h4>
                                        <p className="description"> I help enterprises leverage the power of blockchain technologies
                                            and solutions to achieve next-level transparency and automation in their business processes.</p>
                                        {/* <a className="read-more-button" href="#"><i className="feather-arrow-right"></i></a> */}
                                    </div>
                                </div>
                                {/* <a className="over-link" href="#"></a> */}
                            </div>
                        </div>
                        {/* <!-- End SIngle Service --> */}
                    </div>
                </div>
            </div>
            {/* <!-- End Service Area  --> */}

        </>
    )
}

export default Features